var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrafikkregulering(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 500.368 615.888",
    width: "500.368px",
    height: "615.888px",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsBx: "https://boxy-svg.com",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("grid", {
    x: 0,
    y: 0,
    width: 95.046,
    height: 95.046
  }), /*#__PURE__*/React.createElement("export", null, /*#__PURE__*/React.createElement("file", {
    format: "svg"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M 499.654 250.716 C 499.654 358.657 435.632 423.213 368.749 490.495 C 328.336 529.769 289.377 570.443 250.345 611.111 C 211.393 570.443 172.362 529.769 131.947 490.495 C 65.138 423.213 0 358.657 0 250.716 C 0 217.791 6.465 185.187 19.029 154.769 C 31.593 124.353 50.004 96.716 73.224 73.436 C 96.437 50.151 123.998 31.689 154.326 19.091 C 184.66 6.486 217.168 0 250 0 C 282.832 0 315.34 6.486 345.673 19.091 C 376 31.689 403.561 50.151 426.783 73.436 C 449.996 96.716 468.406 124.353 480.977 154.769 C 493.541 185.187 500 217.791 500 250.716 L 499.654 250.716 Z",
    fill: "white",
    style: {
      transformOrigin: "206.249px 305.555px"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g-1",
    transform: "matrix(1.756067, 0, 0, -1.651205, 27.19374, 368.949043)",
    style: {}
  }, /*#__PURE__*/React.createElement("g", {
    id: "g10",
    transform: "scale(0.1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 90.3516,1.07031 c -48.961,0 -89.27738,39.60159 -89.27738,89.28129 0,16.5584 4.32031,30.9574 12.24218,44.6364 L 1199.16,2189.88 c 34.56,59.75 120.23,59.03 155.51,0 L 2539.79,134.988 c 7.92,-13.679 12.24,-28.797 12.24,-44.6364 0,-49.6797 -39.6,-89.28129 -89.28,-89.28129 H 90.3516",
    style: {
      fill: "#f14824",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 90.3516,1.07031 c -48.961,0 -89.27738,39.60159 -89.27738,89.28129 0,16.5584 4.32031,30.9574 12.24218,44.6364 L 1199.16,2189.88 c 34.56,59.75 120.23,59.03 155.51,0 L 2539.79,134.988 c 7.92,-13.679 12.24,-28.797 12.24,-44.6364 0,-49.6797 -39.6,-89.28129 -89.28,-89.28129 z",
    style: {
      fill: "none",
      stroke: "#f14824",
      strokeWidth: 2.15,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1276.91,1787.39 2153.15,268.91 H 399.965 Z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1276.91,1787.39 2153.15,268.91 H 399.965 Z",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 2.15,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 813.953,415.07 v -35.281 c 27.36,0 54,8.641 77.043,24.481 22.32,15.839 49.68,24.48 77.035,24.48 27.364,0 54.719,-9.359 77.039,-24.48 23.05,-15.84 49.69,-24.481 77.04,-24.481 27.36,0 54.73,8.641 77.05,24.481 22.31,15.839 49.67,24.48 77.75,24.48 27.36,0 54.73,-9.359 77.05,-24.48 21.59,-15.84 48.96,-24.481 77.04,-24.481 27.35,0 54,8.641 77.03,24.481 22.32,15.839 49.68,24.48 77.05,24.48 27.35,0 54.71,-9.359 77.03,-24.48 23.05,-15.84 49.68,-24.481 77.05,-24.481 v 35.281 c -27.37,0 -54,8.641 -77.05,24.481 -22.32,16.558 -49.68,24.48 -77.03,25.199 -27.37,-0.719 -54.73,-8.641 -77.05,-24.48 -23.03,-16.559 -49.68,-24.481 -77.03,-25.2 -28.08,0 -55.45,8.641 -77.04,24.481 -22.32,16.558 -49.69,24.48 -77.05,25.199 -28.08,-0.719 -55.44,-8.641 -77.75,-24.48 -22.32,-16.559 -49.69,-24.481 -77.05,-25.2 -27.35,0 -53.99,8.641 -77.04,24.481 -22.32,16.558 -49.675,24.48 -77.039,25.199 -27.355,-0.719 -54.715,-8.641 -77.035,-24.48 -23.043,-16.559 -49.683,-24.481 -77.043,-25.2 v 0",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 813.953,415.07 v -35.281 c 27.36,0 54,8.641 77.043,24.481 22.32,15.839 49.68,24.48 77.035,24.48 27.364,0 54.719,-9.359 77.039,-24.48 23.05,-15.84 49.69,-24.481 77.04,-24.481 27.36,0 54.73,8.641 77.05,24.481 22.31,15.839 49.67,24.48 77.75,24.48 27.36,0 54.73,-9.359 77.05,-24.48 21.59,-15.84 48.96,-24.481 77.04,-24.481 27.35,0 54,8.641 77.03,24.481 22.32,15.839 49.68,24.48 77.05,24.48 27.35,0 54.71,-9.359 77.03,-24.48 23.05,-15.84 49.68,-24.481 77.05,-24.481 v 35.281 c -27.37,0 -54,8.641 -77.05,24.481 -22.32,16.558 -49.68,24.48 -77.03,25.199 -27.37,-0.719 -54.73,-8.641 -77.05,-24.48 -23.03,-16.559 -49.68,-24.481 -77.03,-25.2 -28.08,0 -55.45,8.641 -77.04,24.481 -22.32,16.558 -49.69,24.48 -77.05,25.199 -28.08,-0.719 -55.44,-8.641 -77.75,-24.48 -22.32,-16.559 -49.69,-24.481 -77.05,-25.2 -27.35,0 -53.99,8.641 -77.04,24.481 -22.32,16.558 -49.675,24.48 -77.039,25.199 -27.355,-0.719 -54.715,-8.641 -77.035,-24.48 -23.043,-16.559 -49.683,-24.481 -77.043,-25.2 z",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 2.15,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path26"
  }))), /*#__PURE__*/React.createElement("text", {
    style: {
      whiteSpace: "pre",
      fill: "rgb(51, 51, 51)",
      fontFamily: "Arial, sans-serif",
      fontSize: 133
    },
    x: 169.212,
    y: 302.621
  }, "TR"));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrafikkregulering);
export default __webpack_public_path__ + "static/media/trafikkregulering.6175157baa01d94c9f3101affd0af145.svg";
export { ForwardRef as ReactComponent };